import type {HighlightColor} from './annotationTypes';

/**
 * The same fills the marks are painted with (annotations-highlights.scss), for the
 * chrome that has to restate a mark: swatches, quoted text.
 */
export const HIGHLIGHT_BACKGROUND_CLASS: Record<HighlightColor, string> = {
  yellow: 'bg-(--color-background-highlight-yellow)',
  blue: 'bg-(--color-background-highlight-blue)',
  pink: 'bg-(--color-background-highlight-pink)'
};

/**
 * Holds a mark's fill across an atomic button's states, which otherwise revert to the
 * grey `secondary` fill on hover at a specificity no utility can outrank.
 */
export const HIGHLIGHT_BUTTON_CLASS_BY_COLOR: Record<HighlightColor, string> = {
  yellow: [
    '[--button-background-color:var(--color-background-highlight-yellow)]',
    '[--button-background-color--hover:var(--color-background-highlight-yellow-hover)]',
    '[--button-background-color--active:var(--color-background-highlight-yellow-pressed)]'
  ].join(' '),
  blue: [
    '[--button-background-color:var(--color-background-highlight-blue)]',
    '[--button-background-color--hover:var(--color-background-highlight-blue-hover)]',
    '[--button-background-color--active:var(--color-background-highlight-blue-pressed)]'
  ].join(' '),
  pink: [
    '[--button-background-color:var(--color-background-highlight-pink)]',
    '[--button-background-color--hover:var(--color-background-highlight-pink-hover)]',
    '[--button-background-color--active:var(--color-background-highlight-pink-pressed)]'
  ].join(' ')
};
